export default {
  brand: 'USFansSheet.help',
  language: 'Język',

  'meta.title': 'USFans Spreadsheet 2026 — Znaleziska, QC, Recenzje i Poradniki',
  'meta.desc': 'Poznaj USFans Spreadsheet — znaleziska produktów, poradniki QC, recenzje, koszty wysyłki i bezpieczeństwo. Zaktualizowane na 2026.',
  'meta.articleTitle': 'Czym Jest USFans Spreadsheet? Kompletny Poradnik 2026',
  'meta.articleDesc': 'Dowiedz się, czym jest USFans Spreadsheet, jak go używać, jakie ma kategorie, QC, wysyłkę i wskazówki bezpieczeństwa.',

  'nav.home': 'Strona główna',
  'nav.shop': 'Przewodnik zakupowy',
  'nav.spreadsheet': 'Arkusz',
  'nav.categories': 'Kategorie',
  'nav.guides': 'Poradniki',

  'hero.badge': 'Niezależne źródło · Zaktualizowane na 2026',
  'hero.title': 'USFans Spreadsheet — Znajdź Lepsze Produkty, QC i Poradniki Zakupowe',
  'hero.subtitle': 'Poznaj USFans Spreadsheet w jednym uporządkowanym miejscu. Odkrywaj znaleziska produktów, poradniki kategorii, wskazówki QC, porady dotyczące wysyłki i zasoby bezpieczeństwa przed zakupem.',
  'hero.ctaPrimary': 'USFans Spreadsheet',
  'hero.ctaSecondary': 'Kup Teraz',
  'hero.trust': 'Niezależny · Skupiony na bezpieczeństwie · Wielojęzyczny',

  'categories.title': 'Przeglądaj Kategorie Produktów',
  'categories.subtitle': 'Przejdź bezpośrednio do dowolnej kategorii na głównej platformie.',
  'categories.dropdownLabel': 'Wybierz kategorię',
  'categories.viewAll': 'Zobacz wszystkie kategorie',

  'cat.shoes': 'Buty',
  'cat.hoodies': 'Bluzy / Swetry',
  'cat.tshirts': 'Koszulki',
  'cat.jackets': 'Kurtki',
  'cat.pants': 'Spodnie / Szorty',
  'cat.headwear': 'Nakrycia Głowy',
  'cat.sets': 'Zestawy',
  'cat.underwear': 'Bielizna / Majtki',
  'cat.jersey': 'Koszulki Meczowe',
  'cat.accessories': 'Akcesoria',
  'cat.bags': 'Torby',
  'cat.belts': 'Paski',
  'cat.perfumes': 'Perfumy',
  'cat.other': 'Inne Rzeczy',

  'what.title': 'Czym Jest USFans Spreadsheet?',
  'what.p1': 'USFans Spreadsheet to uporządkowany sposób na organizowanie znalezisk produktów, linków, kategorii i informacji zakupowych w jednym miejscu.',
  'what.p2': 'Zamiast przewijać niekończące się strony, arkusz pomaga porównywać opcje, sprawdzać notatki QC oraz rozumieć procesy wysyłki i magazynu przed złożeniem zamówienia.',
  'what.p3': 'Został zaprojektowany jako informacyjny katalog — skrót badawczy dla każdego, kto chce efektywniej przeglądać produkty.',
  'what.cta': 'Dowiedz Się, Jak To Działa',
  'what.finds.title': 'Znaleziska produktów',
  'what.finds.desc': 'Przeglądaj uporządkowane odkrycia produktów w każdej kategorii.',
  'what.qc.title': 'Zdjęcia QC',
  'what.qc.desc': 'Sprawdzaj zdjęcia kontroli jakości przed potwierdzeniem zamówienia.',
  'what.shipping.title': 'Wysyłka',
  'what.shipping.desc': 'Poznaj trasy, wagę i koszty konsolidacji.',
  'what.sellers.title': 'Sprzedawcy',
  'what.sellers.desc': 'Sprawdzaj szczegóły i reputację sprzedawców przed zakupem.',

  'guideCard.title': 'Kompletny Poradnik USFans Spreadsheet',
  'guideCard.summary': 'Wszystko, co musisz wiedzieć o USFans Spreadsheet — czym jest, jak go używać, kategorie, QC, wysyłka i bezpieczeństwo — w jednym poradniku dla początkujących.',
  'guideCard.readTime': '8 min czytania',
  'guideCard.cta': 'Przeczytaj poradnik',

  'pillar.title': 'Najnowsze poradniki i recenzje',
  'pillar.subtitle': 'Świeże, szczegółowe artykuły USFans Spreadsheet — recenzje, wysyłka, bezpieczeństwo i więcej.',
  'pillar.readMore': 'Przeczytaj artykuł',

  'cat.label.review': 'Recenzja',
  'cat.label.shipping': 'Wysyłka',
  'cat.label.coupon': 'Kupon',
  'cat.label.warehouse': 'Magazyn',
  'cat.label.safety': 'Bezpieczeństwo',
  'cat.label.qc': 'Poradnik QC',
  'cat.label.guide': 'Poradnik',

  'faq.title': 'Często Zadawane Pytania',
  'faq.q1': 'Czym jest USFans Spreadsheet?',
  'faq.a1': 'To informacyjny katalog, który porządkuje znaleziska produktów, linki, kategorie i notatki zakupowe, dzięki czemu możesz zbadać ofertę przed zakupem.',
  'faq.q2': 'Czy USFans Spreadsheet jest bezpieczny?',
  'faq.a2': 'Arkusz to katalog informacji, a nie gwarancja. Zawsze weryfikuj linki, sprzedawców i szczegóły na głównej platformie przed zakupem.',
  'faq.q3': 'Jak działają koszty wysyłki?',
  'faq.a3': 'Wysyłka zależy od wagi, wymiarów, miejsca docelowego i wybranej trasy lub poziomu usługi. Konsolidacja może również zmienić ostateczną cenę.',
  'faq.q4': 'Gdzie mogę znaleźć kody rabatowe?',
  'faq.a4': 'Promocje są publikowane przez samą platformę. Sprawdzaj oficjalne kanały na głównej stronie i zawsze weryfikuj warunki oraz datę ważności.',
  'faq.q5': 'Czy USFans jest legalne?',
  'faq.a5': 'USFans to prawdziwa platforma, ale zawsze zalecamy niezależne weryfikowanie sprzedawców, informacji o płatnościach i linków przed złożeniem zamówienia.',

  'footer.disclaimer': 'USFansSheet.help jest niezależnym źródłem informacji i nie jest powiązany, wspierany ani obsługiwany przez USFans.',
  'footer.rights': 'Wszelkie prawa zastrzeżone.',
  'footer.about': 'O tej stronie',

  'notFound.title': 'Nie znaleziono strony',
  'notFound.desc': 'Strona, której szukasz, nie istnieje lub została przeniesiona.',

  'article.backHome': 'Wróć do strony głównej',
  'article.notFound': 'Nie znaleziono artykułu',
  'article.updated': 'Ostatnia aktualizacja',
  'article.readTime': 'Czas czytania',
  'article.minRead': 'min czytania',
  'article.title': 'Czym Jest USFans Spreadsheet? Kompletny Poradnik 2026',
  'article.quickAnswerTitle': 'Krótka Odpowiedź',
  'article.quickAnswer': 'USFans Spreadsheet to informacyjny katalog, który porządkuje znaleziska produktów, linki do kategorii, notatki QC i wskazówki zakupowe w jednym uporządkowanym miejscu. Pomaga badać produkty przed zakupem — ale sam niczego nie sprzedaje i nie jest gwarancją, że każdy sprzedawca lub link jest bezpieczny.',
  'article.tocTitle': 'Na tej stronie',

  'article.s1Title': 'Czym Jest USFans Spreadsheet?',
  'article.s1Body': 'USFans Spreadsheet to scentralizowany sposób na przeglądanie znalezisk produktów w wielu kategoriach, od butów i odzieży po torby i akcesoria. Zamiast przekopywać się przez rozproszone strony, możesz zobaczyć uporządkowane linki i notatki w jednym widoku. To narzędzie badawcze, a nie sklep — wszystkie zakupy odbywają się na głównej platformie.',

  'article.s2Title': 'Jak Korzystać z USFans Spreadsheet',
  'article.s2Body': 'Zacznij od wybrania kategorii, która Cię interesuje, a następnie przejrzyj wymienione pozycje oraz wszelkie notatki QC i dotyczące wysyłki. Porównaj kilka opcji, zanim przejdziesz do głównej strony. Poświęcenie kilku minut na badanie zwykle prowadzi do płynniejszego doświadczenia zakupowego.',

  'article.s3Title': 'Wyjaśnienie Kategorii Produktów',
  'article.s3Body': 'Arkusz obejmuje szeroki zakres kategorii, w tym buty, bluzy i swetry, koszulki, kurtki, spodnie i szorty, nakrycia głowy, zestawy, bieliznę, koszulki meczowe, akcesoria, torby, paski, perfumy i inne przedmioty. Każda kategoria grupuje powiązane produkty, dzięki czemu możesz przeglądać je efektywniej.',

  'article.s4Title': 'QC i Kontrole Jakości',
  'article.s4Body': 'QC, czyli kontrola jakości, to etap, na którym produkty są sprawdzane przed wysyłką. Wielu kupujących korzysta ze zdjęć QC, aby sprawdzić szczegóły, takie jak szwy, rozmiar i kolor. Jeśli QC jest dostępne dla danego produktu, dokładnie przejrzyj te zdjęcia przed potwierdzeniem zamówienia.',

  'article.s5Title': 'Podstawy Wysyłki i Magazynu',
  'article.s5Body': 'Koszt wysyłki zależy od takich czynników, jak waga, wymiary, miejsce docelowe i wybrany poziom usługi. Niektóre zamówienia przechodzą przez magazyn, gdzie przedmioty mogą być przechowywane, fotografowane i konsolidowane w mniejszą liczbę paczek — co czasami może obniżyć całkowity koszt wysyłki.',

  'article.s6Title': 'Czy USFans Jest Bezpieczne i Legalne?',
  'article.s6Body': 'USFans to prawdziwa platforma używana przez wielu kupujących, ale żaden katalog nie może zagwarantować, że każdy sprzedawca, produkt lub link jest bezpieczny. Zawsze niezależnie weryfikuj linki, reputację sprzedawcy, szczegóły płatności i informacje o produkcie przed zakupem.',

  'article.s7Title': 'Wskazówki dla Początkujących',
  'article.s7Body': 'Jeśli dopiero zaczynasz, zrób małe zamówienie, przejrzyj zdjęcia QC, gdy są dostępne, i zachowaj zapisy zamówienia oraz korespondencji. Dokładnie sprawdzaj warunki wysyłki i wszelkie warunki promocji. Najpierw zbadaj, potem kupuj z pewnością.',

  'article.tableTitle': 'Szybkie Porównanie: Badanie vs. Kupowanie Bezpośrednio',
  'article.tableHeaders': ['Czynnik', 'Najpierw Badanie', 'Kupowanie Bezpośrednio', 'Najlepsze Dla'],
  'article.tableRows': [
    ['Koszt', 'Przeglądanie za darmo', 'Płatność przy kasie', 'Planowanie budżetu'],
    ['Szybkość', 'Wolniej (najpierw sprawdzasz)', 'Szybciej', 'Pilne zamówienia'],
    ['QC', 'Możesz przejrzeć zdjęcia', 'Można pominąć kontrole', 'Kupujący zorientowani na jakość'],
    ['Pewność', 'Wyższa po badaniu', 'Zależy od oferty', 'Początkujący'],
  ],

  'article.faqTitle': 'Często Zadawane Pytania',
  'article.faq1q': 'Czym jest USFans Spreadsheet?',
  'article.faq1a': 'To uporządkowany katalog znalezisk produktów, linków do kategorii, notatek QC i wskazówek zakupowych, który pomaga badać ofertę przed zakupem.',
  'article.faq2q': 'Czy USFans Spreadsheet jest darmowy?',
  'article.faq2a': 'Przeglądanie katalogu jest bezpłatne. Płacisz tylko za przedmioty, które zdecydujesz się kupić na głównej platformie.',
  'article.faq3q': 'Jak znaleźć zdjęcia QC?',
  'article.faq3a': 'Zdjęcia QC są zwykle dostępne dla przedmiotów przechodzących przez magazyn. Sprawdź każdą ofertę na głównej platformie, aby zobaczyć dostępne zdjęcia kontrolne.',
  'article.faq4q': 'Czy każdy link w arkuszu jest bezpieczny?',
  'article.faq4a': 'Niekoniecznie. Arkusz ma charakter informacyjny, więc zawsze niezależnie weryfikuj linki, sprzedawców i szczegóły płatności przed zakupem.',

  'article.relatedTitle': 'Powiązane Poradniki',
  'article.related1': 'Wróć do strony głównej USFans Spreadsheet',
  'article.related2': 'Przeglądaj wszystkie kategorie produktów',
  'article.ctaTitle': 'Gotowy, aby odkrywać?',
  'article.ctaBody': 'Otwórz USFans Spreadsheet i rozpocznij badanie produktów już dziś.',
  'article.cta': 'Odkryj USFans Spreadsheet',
};